import React from 'react';

import CaseHeader from './CaseHeader';
import CaseBody from './CaseBody';
import CaseActions from './CaseActions';

const CaseCard = ({ caseData, hideSave }) => {

  const { author, specialty, timeAgo, tags, title, description, hashtags, supportCount, commentCount } = caseData;

  return (
    <article className="bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md 
                        transition-all duration-300 hover:border-gray-300">
      <div className="flex justify-between items-start">
        <CaseHeader
          author={author}
          specialty={specialty}
          jobRole={caseData.jobRole || caseData.authorJobRole || caseData.author?.jobRole}
          timeAgo={timeAgo}
          tags={tags}
          avatarUrl={caseData.avatarUrl || caseData.authorAvatar || caseData.author?.avatarUrl}
          isRestricted={caseData.isRestricted}
        />
      </div>
      
      <CaseBody
        title={title}
        description={description}
        hashtags={hashtags}
        postType={caseData.postType}
        discussionType={caseData.discussionType}
      />
      
      <CaseActions
        caseId={caseData.id}
        supportCount={supportCount}
        commentCount={commentCount}
        isLiked={caseData.isLiked}
        hideSave={hideSave}
      />
    </article>
  );
};

export default CaseCard;